<template>
    <div class="flex space-x-1 items-center mb-4">
        <UIIcon
            v-if="icon"
            :icon="icon"
            :size="18"
            class="shape-neutral-base shrink-0"
        />
        <div
            v-if="html"
            class="content-xs-ux-medium text-neutral-extra-subtle line-clamp-1"
        >
            <UIHtml
                :html="html"
                class="prose max-w-auto leading-5 text-[length:inherit] text-inherit"
                style="overflow-wrap: anywhere;"
            />
        </div>
    </div>
</template>

<script setup>
    import UIHtml from '@/components/ui/UIHtml.vue'

    const props = defineProps({
        icon: Object,
        html: String,
    })
</script>
